import React, { useState } from "react"
import * as FileSaver from "file-saver"
import * as XLSX from "xlsx"
import { Spinner } from "reactstrap"
import { get } from "helpers/api_helper"
import moment from "moment"
import { toast } from "react-toastify"

export const ExportJsonToExcelAPI = ({
  apiPath = ``,
  fileName = "excel",
  dateColumns = [],
  mapHeaderColumn = {},
  colorBox = "btn-success",
}) => {
  const [exportLoading, setExportLoading] = useState(false)

  const exportToExcel = (
    jsonData = [],
    exportFileName = "excel",
    dateCol = [],
    mapColumn = {}
  ) => {
    const rows = Array.isArray(jsonData) && jsonData.length > 0 ? jsonData : [{}]
    const dateColumnsToFormat = [
      ...new Set([
        "createdAt",
        "createdDate",
        "updatedAt",
        "updatedDate",
        ...dateCol,
      ]),
    ]

    const exportRows = rows.map(sourceRow => {
      const item = { ...sourceRow }
      for (const dateColumn of dateColumnsToFormat) {
        if (item[dateColumn]) {
          item[dateColumn] = moment(item[dateColumn]).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }
      }

      const row = {}
      for (const key of Object.keys(mapColumn)) {
        row[mapColumn[key]] = item[key] ?? ""
      }
      return row
    })

    const worksheet = XLSX.utils.json_to_sheet(exportRows)
    for (const cellAddress of Object.keys(worksheet)) {
      if (cellAddress.startsWith("!")) continue
      const cell = worksheet[cellAddress]
      if (typeof cell?.v === "string" && /^https?:\/\/\S+$/i.test(cell.v)) {
        cell.l = { Target: cell.v }
      }
    }

    const workbook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    }
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    })
    FileSaver.saveAs(
      data,
      `${exportFileName}-${moment().unix()}-.xlsx`
    )
  }

  const handleExport = async () => {
    if (exportLoading) return
    setExportLoading(true)

    try {
      const result = await get(process.env.REACT_APP_BACKEND_URL + apiPath)
      const responseRows = Array.isArray(result?.data) ? result.data : []
      const headerMap = { ...mapHeaderColumn }

      for (const field of result?.other?.removeField ?? []) {
        delete headerMap[field]
      }

      exportToExcel(responseRows, fileName, dateColumns, headerMap)
    } catch (error) {
      console.error("Failed to export report:", error)
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Please try again."
      toast.error(`Unable to download report: ${errorMessage}`)
    } finally {
      setExportLoading(false)
    }
  }

  return (
    <button
      type="button"
      className={`btn ${colorBox}`}
      onClick={handleExport}
      disabled={exportLoading}
      aria-label="Export report"
    >
      {exportLoading ? (
        <Spinner size="sm" color="light" style={{ zoom: "0.8" }} />
      ) : (
        <i className="bx bx-export" />
      )}
    </button>
  )
}
